import React from 'react';

import './not-found.scss';

const NotFound: React.FC = (): JSX.Element => {
  return (
    <main className="not-found">
      <div className="not-found-content">
        <h1>404</h1>
        <p>Page not found</p>
      </div>
    </main>
  );
};

export default NotFound;
